import { CatalogItemType } from '@common/model/catalog/item/type';
import { ClientType } from '@common/model/client/clientType';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { CLIENT_EMPLOYER_DEFAULT_NAME } from '@common/const/client/defaults';
import { useClientProfile } from 'src/entities/client';
import { useConnectWithCatalogItemAuthor } from 'src/features/catalogItem/connect';
// import { useWithShowPatronageHints } from 'src/features/client/current/patronage';
import { mapCatalogItemToClientSelection, useAuthInterceptor } from 'src/features/auth';
// import { useBurgerMenuController } from 'src/features/burgerMenu';

export const useConnectAction = (catalogItem: CatalogItemViewModel | undefined): [() => void, { isAvailable: boolean }] => {
  const clientProfile = useClientProfile();
  // const burgerMenuController = useBurgerMenuController();
  // const [withShowPatronageHints] = useWithShowPatronageHints();
  const connect = useConnectWithCatalogItemAuthor();
  const withAuth = useAuthInterceptor();
  const isAvailable =
    !clientProfile || (catalogItem ? clientTypeToSuitableCatalogItemType(clientProfile.type as ClientType) === catalogItem.type : false);

  const fn = () => {
    if (catalogItem) {
      return withAuth(connect, mapCatalogItemToClientSelection(catalogItem))(catalogItem.id);

      // if (!clientProfile) {
      //   if (catalogItem.type === CatalogItemType.Resume) {
      //     login({
      //       clientSelection: {
      //         catalogType: catalogItem.type,
      //         careerId: catalogItem.careerId,
      //         cityId: catalogItem.city?.id,
      //         name: CLIENT_EMPLOYER_DEFAULT_NAME,
      //       },
      //     });
      //     // if (!catalogItem.clientProfile) {
      //     //   login();
      //     //   // burgerMenuController.open();
      //     // } else {
      //     //   // openModal(ANOTHER_CLIENT_CONTACTS_MODAL_NAME, {
      //     //   //   clientId: catalogItem.clientProfile.id,
      //     //   //   onContactClick: () => login() /* burgerMenuController.open */,
      //     //   // });
      //     // }
      //   } else {
      //     login();
      //     // burgerMenuController.open();
      //   }
      // } else {
      //   if (!isAvailable) {
      //     return;
      //   }

      //   const actionFn = () => connect(catalogItem.id);

      //   if (clientProfile?.type === ClientType.Specialist) {
      //     withShowPatronageHints(actionFn);
      //   } else {
      //     actionFn();
      //   }
      // }
    }
  };

  return [fn, { isAvailable }];
};
